import Carousel from '../components/carousel';
import SectionContainer from "../sections/section-container";
import ProductSection from "../sections/product-section";
import RecentlyViewedProductsSection from "../sections/recently-viewed-products";
import ProductRecommendationsSection from "../sections/product-recommendations";

const sections = new SectionContainer();

// Sections used on product page
sections.register('carousel', Carousel);
sections.register("product", ProductSection);
sections.register("recently-viewed-products", RecentlyViewedProductsSection);
sections.register("product-recommendations", ProductRecommendationsSection);
